export const getArrayFirstItems = <TStatsItem extends { value: number }>(
    array: readonly TStatsItem[],
    quantity: number,
): TStatsItem[] => array.filter((item, i) => item.value > 0 && i < quantity);
